module.exports = __webpack_public_path__ + "static/iwgb-061303a1f4f77cf8cafd3f0757f8767d.png";